export default __webpack_public_path__ + "static/NBInternationalPro-Light-174b4b3bda9e80bb253e2c07d82268ce.woff";